import { InjectableService } from "@/shared/services/InjectableService";
import { Rule } from "../models/Rule";
import { RuleValidationResult } from "./RuleValidationResult";



export abstract class RuleValidationService extends InjectableService {

    public abstract validateRules(rules: Array<Rule>, result?: RuleValidationResult): RuleValidationResult;

}